const commonLabels = {
  SUBMIT: 'Submit',
  CONTINUE: 'Continue',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  DATE_OF_BIRTH: 'Date of Birth',
  CARD_NUMBER_ERROR: 'Enter your 13 digit Everyday Rewards Plus card number',
};

export const LABELS = {
  stepper: {
    LOGIN: 'Login',
    TERMS_CONDITIONS: 'Terms and Conditions',
    MEMBER_TYPE: 'Member Type',
    MEMBER_UPDATE: 'Member Update',
    SET_PASSWORD: 'Set Password',
    CONFIRMATION: 'Confirmation',
  },
  breadCrumb: {
    TERMS: 'Terms and Conditions',
    MEMBER_TYPE: 'Member Selection',
    MEMBER_UPDATE: 'Update Details',
  },
  validation: {
    VALIDATION_HEADER: 'Everyday Rewards Plus Card',
    VALIDATION_SUB_HEADER: 'Activate your new card',
    VALIDATION_DESCRIPTION:
      'Enjoy exclusive team discounts, plus all the benefits of Everyday Rewards.',
    EMPLOYEE_NUMBER: 'Employee Number',
    CARD_NUMBER: 'Card Number',
    VALIDATION_SUBMIT: 'Activate Now',
    CARD_NUMBER_ERROR: commonLabels.CARD_NUMBER_ERROR,
    CARD_NUMBER_TOOLTIP:
      'Enter your 13 digit Everyday Rewards Plus card number',
    EMPLOYEE_NUMBER_ERROR:
      'Please enter alphanumerics only and must not exceed 20',
    EMPLOYEE_NUMBER_TOOLTIP: 'Enter your Employee number',
    IMAGE: '/assets/box-pluscard-910-6081.jpg',
    MISSING_MOBILE_EMAIL_ERROR:
      "We are unable to process this request as we hold invalid email and/or mobile phone number information. Please refer to FAQ's on how to update your personal information.",
  },
  memberType: {
    MEMBER_TYPE_HEADER: 'Are you an existing Everyday Rewards member?',
    MEMBER_TYPE_DESCRIPTION:
      'Please enter details exactly as they appear in your Everyday Rewards account.',
    NOT_MEMBER: 'Not an Everyday Rewards member?',
    MEMBER_TYPE_FIRST_NAME: commonLabels.FIRST_NAME,
    MEMBER_TYPE_LAST_NAME: commonLabels.LAST_NAME,
    MEMBER_TYPE_CARD_NO: 'Existing Card Number',
    MEMBER_TYPE_DOB: commonLabels.DATE_OF_BIRTH,
    MEMBER_TYPE_SUBMIT: commonLabels.SUBMIT,
    MEMBER_TYPE_CONTINUE: commonLabels.CONTINUE,
    MEMBER_TYPE_FIRST_NAME_ERROR:
      'Enter First Name. (Dots, quotes and hyphens allowed)',
    MEMBER_TYPE_LAST_NAME_ERROR:
      'Enter Last Name. (Dots, quotes and hyphens allowed)',
    MEMBER_TYPE_CARD_NO_ERROR: commonLabels.CARD_NUMBER_ERROR,
    MEMBER_TYPE_DOB_ERROR: 'Please enter Date of Birth',
  },
  memberUpdate: {
    MEMBER_HEADER: 'Your Details',
    MEMBER_DESCRIPTION:
      "For existing Everyday Rewards/Everyday Rewards Plus card holders we'll transfer all your rewards to your new Everyday Rewards Plus card",
    MEMBER_FIRST_NAME: 'First Name',
    MEMBER_LAST_NAME: 'Last Name',
    MEMBER_DOB: 'Date of Birth',
    MEMBER_GENDER: 'Gender',
    MEMBER_EMAIL: 'Email Address',
    MEMBER_MOBILE: 'Contact Number',
    MEMBER_RESENDENTIAL_ADDRESS: 'Address',
    MEMBER_PAYROLL_SYSTEM: ' (Payroll System)',
    MEMBER_MAILING_ADDRESS: 'Mailing Address',
    MEMBER_UPDATE_HEADER: 'Preferred Contact Details',
    MEMBER_UPDATE_DESCRIPTION:
      'Everyday Rewards will send messages to the Preferred Contact Details below.',
    MEMBER_UPDATE_ADDRESS_UNIT: 'Unit Number',
    MEMBER_UPDATE_ADDRESS_UNIT_ERROR:
      'Please enter unit number. Alphabets, space, forward slash, numbers and hyphens are only allowed',
    MEMBER_UPDATE_ADDRESS_STREET_NO: 'Street Number',
    MEMBER_UPDATE_ADDRESS_STREET_ERROR:
      'Please enter street number. Alphabets, space, forward slash, numbers and hyphens are only allowed',
    MEMBER_UPDATE_ADDRESS_STREET_NAME: 'Street Name',
    MEMBER_UPDATE_ADDRESS_STREET_NAME_ERROR:
      'Please enter street name. Alphabets, quotes, hyphens, spaces are only allowed',
    MEMBER_UPDATE_ADDRESS_SUBURB: 'Suburb',
    MEMBER_UPDATE_ADDRESS_SUBURB_ERROR:
      'Please enter suburb. Alphabets, spaces are only allowed',
    MEMBER_UPDATE_ADDRESS_POSTCODE: 'Postcode',
    MEMBER_UPDATE_ADDRESS_POSTCODE_ERROR:
      'Please enter postcode. Numbers are only allowed',
    MEMBER_UPDATE_ADDRESS_STATE: 'State',
    MEMBER_UPDATE_ADDRESS_STATE_ERROR: 'Please select a state.',
    MEMBER_PREFERRED_MAIL: 'Preferred Email Address',
    MEMBER_PREFERRED_MAIL_ERROR: 'Please enter a valid email address.',
    MEMBER_PREFERRED_MOBILE: 'Preferred Contact Number',
    MEMBER_PREFERRED_MOBILE_ERROR: 'Please enter a valid mobile number.',
    MEMBER_PASSWORD_HEADER: 'Please confirm your password',
    MEMBER_PASSWORD_DESCRIPTION:
      'Use this password to log into your Everyday Rewards account online. Here you can track your rewards, see current offers, update your details and more.',
    MEMBER_PASSWORD: 'Password',
    MEMBER_CONFIRM_PASSWORD: 'Confirm Password',
    MEMBER_PASSWORD_MISMATCH: 'Passwords do not match.',
    PASSWORD_TOOLTIP:
      'Your password must be 8-20 characters long and contain atleast one uppercase,one lowercase and one number. This will help us keep your account safe.',
    MEMBER_OFFER_CHECKBOX:
      'I would like to receive offers exclusive to team members',
    MEMBER_OFFER_CHECKBOX_TERMS:
      'By selecting this option, you agree to us sending you offers exclusive to Everyday Rewards Plus members. If you do not wish to receive exclusive member offers you may select to opt-out.',
    MEMBER_SUBMIT: commonLabels.SUBMIT,
    MEMBER_SF_TERMS:
      ' *If your mailing address is no longer correct, please update via <a target="_blank" href="https://performancemanager10.successfactors.com/login?company=Woolworths"> SuccessFactors</a>',
  },
  confirmation: {
    CONFIRMATION_YOUR_CARD: 'Your digital card',
    CONFITMATION_ACTIVATED: 'is activated',
    CONFIRMATION_HERO_IMAGE:
      '/assets/EDR-Plus_Pattern-with-card_Landscape_sRGB@300ppi_140323-rect.png',
    CONFIRMATION_ARTICLES: [
      {
        icon: '/assets/ED_REWARDS_SPOT_ILLUS_TEAM_SRGB_1X.PNG',
        title: 'SHARE THE BENEFITS',
        description:
          'Visit Me@Woolies to check your eligibility for a Secondary Everyday Rewards Plus Card.',
        links: [
          {
            text: 'Learn more',
            link: 'https://teamspace.woolworths.com.au/policy?urlName=Everyday-Rewards-Plus-Card-Policy',
          },
        ],
      },
      {
        icon: '/assets/ED_REWARDS_SPOT_ILLUS_PHONE_SRGB_1X.PNG',
        title: 'DOWNLOAD THE APP',
        description:
          'Get more from Everyday Rewards. Never miss a point and unlock app-exclusive offers.',
        links: [
          {
            text: 'Learn more',
            link: 'https://www.everyday.com.au/rewards/app.html',
          },
        ],
      },
      {
        icon: '/assets/ED_REWARDS_SPOT_ILLUS_LOGIN_SRGB_1X.PNG',
        title: 'LOG IN TO EVERYDAY REWARDS',
        description:
          'Use your new card number or the email address linked to your account.',
        links: [
          {
            text: 'Log in',
            link: 'http://everyday.com.au/login',
          },
        ],
      },
    ],
  },
};
